import { merge } from 'lodash';
import legacyEn from '@meitu/x-design-locales-legacy/chunks/saasColor/en.json';
import legacyZhHans from '@meitu/x-design-locales-legacy/chunks/saasColor/zh-Hans.json';
import type { SaasColorLocaleText } from '@meitu/x-design-locales-legacy/types';
import nextEn from '@meitu/x-design-locales-next/en.json';
import type { NextLocaleText } from '@meitu/x-design-locales-next/types';
import nextZhHans from '@meitu/x-design-locales-next/zh-Hans.json';

export type LocaleText = NextLocaleText & SaasColorLocaleText;

const zhMerged = merge({}, nextZhHans, legacyZhHans);
const enMerged = merge({}, nextEn, legacyEn);

export const localeTextMap: Record<string, LocaleText> = {
    'zh-Hans': zhMerged,
    en: enMerged,
};

export type LocaleCode = keyof typeof localeTextMap;

export const SUPPORT_LOCALES = Object.keys(localeTextMap);

function mergeLocaleText(
    locale: string,
    fallback: LocaleText,
    nextLocaleMap: Record<string, unknown>,
    devNextOverrides: Record<string, unknown>,
    legacyLocaleMap: Record<string, unknown>,
) {
    localeTextMap[locale] = merge({}, fallback, nextLocaleMap, devNextOverrides, legacyLocaleMap) as LocaleText;
}

// 浏览器环境外部注入多语言
if (typeof window !== 'undefined' && window.__LOCALE__) {
    const locale = window.__LOCALE__;
    const fallback = localeTextMap[locale] ?? localeTextMap['zh-Hans'];
    const nextLocaleMap = window.__LOCALE_TEXT_NEXT_MAP__ ?? {};
    const devNextOverrides = window.__DEV_NEXT_LOCALE_OVERRIDES__ ?? {};
    const legacyLocaleMap = (window.__LOCALE_TEXT_LEGACY_MAP__?.saasColor ?? {}) as Record<string, unknown>;

    mergeLocaleText(locale, fallback, nextLocaleMap, devNextOverrides, legacyLocaleMap);
} else if (typeof globalThis !== 'undefined') {
    const localeGlobal = globalThis as {
        __FULL_LOCALE_TEXT_MAP__?: Record<string, LocaleText>;
        __DEV_NEXT_LOCALE_OVERRIDES__?: Record<string, unknown>;
    };
    const fullLocaleText = localeGlobal.__FULL_LOCALE_TEXT_MAP__;
    if (fullLocaleText) {
        const devNextOverrides = localeGlobal.__DEV_NEXT_LOCALE_OVERRIDES__ ?? {};
        for (const loc of Object.keys(fullLocaleText)) {
            mergeLocaleText(loc, fullLocaleText[loc]!, {}, devNextOverrides, {});
        }
    }
}
